import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/products/add-ons/$addOnId')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/products/$productId',
      params: {
        orgId: params.orgId,
        productId: String(params.addOnId),
      },
      replace: true,
    })
  },
})
